<template>
    <v-layout full-height align-center justify-center>
        <v-flex sm3>
            <v-card class="pa-3">
                <v-form @submit.prevent="handleSubmit">
                    <v-card-text>
                        <v-text-field
                                label="Username" v-model="credentials.username"></v-text-field>
                        <v-text-field
                                type="password"
                                label="Password" v-model="credentials.password"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout full-height justify-center>
                            <v-btn type="submit" class="button" color="primary">Log In</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>

        <v-dialog
                v-model="loading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    Authenticating...
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="errMsg" max-width="290">
            <v-card>
                <v-card-title class="headline">Unauthorized</v-card-title>
                <v-card-text>
                    <v-layout row>
                        <span>{{ unauthorizedMsg }}</span>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dismiss" flat color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import {UserService} from "../services/user.services";
    import {mapActions, mapGetters, mapState} from "vuex";
    import md5 from 'js-md5'

    export default {
        data() {
            return {
                credentials: {
                    username: '',
                    password: ''
                },
                loading: false,
                errMsg: false
            }
        },
        methods: {
            handleSubmit() {
                if (this.isValidCredentials) {
                    this.loading = true
                    let encoded = Object.assign({}, this.credentials)
                    encoded.password = md5(this.credentials.password)
                    UserService.login(encoded, this.$route)
                }
            },
            dismiss() {
                this.errMsg = false
                this.setUnauthorized(false)
            },
            ...mapActions(
                ["setUnauthorized"]
            )
        },
        computed: {
            isValidCredentials() {
                return this.credentials.username !== ''
                    && this.credentials.password !== ''
            },
            ...mapGetters(
                ["isUnauthorized"],
            ),
            ...mapState(
                [ "unauthorizedMsg" ],
            )
        },
        watch: {
            isUnauthorized(state) {
                if (state) {
                    this.loading = false
                    this.errMsg = true
                }
            }
        }
    }
</script>

<style scoped>
    .button {
        min-width: 150px;
    }
</style>
